export default __webpack_public_path__ + "static/media/sketch.15428060.png";